import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountSelectionPage from './AccountSelectionContainer';
import NoContactNumberPage from '../components/NoContactNumberPage';
import GenericErrorPage from '../components/GenericErrorPage';
import SingleViewAlertsPage from './SingleViewAlerts';
import { Router, Route } from '../router';
import { withSubscription } from '../../src/wrapper/GenericWrapper';
import BalanceAlertsPage from './BalanceAlerts';
import SweepAlertLanding from '../containers/SweepAlertLandingPage';
import TransactionAlertsPage from '../containers/TransactionAlertsLandingPage';
import TransactionAlertsSMELanding from '../containers/TransactionAlertsSMELandingPage';
import IncomingTransactionAlerts from '../containers/IncomingTransactionAlertsPage';
import { hasPhoneNumber } from '../utils/NumberUtils';

export class App extends Component {
  constructor(props) {
    super(props);
    this.getDefaultRoute = this.getDefaultRoute.bind(this);
  }

  getDefaultRoute() {
    const {
      WBAAlert,
      userInfo,
      userDetails,
      bulkBalanceError,
      bulkProjectionError,
      userError,
      isAccountListError,
    } = this.props;
    if (
      WBAAlert.isError ||
      bulkBalanceError ||
      bulkProjectionError ||
      userError ||
      isAccountListError
    ) {
      return '/errorpage';
    }
    if (!hasPhoneNumber(userDetails)) {
      return '/nocontactpage';
    }
    if (userInfo.accountId) {
      return '/singlealerts';
    }
    return '/accounts';
  }
  render() {
    const { masterCardAlertBack, ...restProps } = this.props;
    return (
      <Router defaultRoute={this.getDefaultRoute()} exitCallback={masterCardAlertBack}>
        <Route path="/singlealerts" Component={SingleViewAlertsPage} componentProps={restProps} />
        <Route path="/accounts" Component={AccountSelectionPage} componentProps={restProps} />
        <Route path="/nocontactpage" Component={NoContactNumberPage} componentProps={restProps} />
        <Route path="/errorpage" Component={GenericErrorPage} componentProps={restProps} />
        <Route path="/alerts" Component={BalanceAlertsPage} componentProps={restProps} />
        <Route path="/sweeps" Component={SweepAlertLanding} componentProps={restProps} />
        <Route
          path="/transactions"
          Component={TransactionAlertsSMELanding}
          componentProps={restProps}
        />
        <Route
          path="/outgoingtransactions"
          Component={TransactionAlertsPage}
          componentProps={restProps}
        />
        <Route
          path="/incomingtransactions"
          Component={IncomingTransactionAlerts}
          componentProps={restProps}
        />
      </Router>
    );
  }
}
App.propTypes = {
  source: PropTypes.string.isRequired,
  userInfo: PropTypes.shape({}).isRequired,
  accountList: PropTypes.shape({}),
  userDetails: PropTypes.shape({}),
  masterCardAlertBack: PropTypes.func,
  content: PropTypes.shape({}),
  retry: PropTypes.func,
  WBAAlert: PropTypes.shape({}),
  bulkProjectionError: PropTypes.bool,
  bulkBalanceError: PropTypes.bool,
  userError: PropTypes.bool,
  isAccountListError: PropTypes.bool,
};

export default withSubscription(App);
